import { render, staticRenderFns } from "./ApiSettings.vue?vue&type=template&id=9bd315e4&scoped=true"
import script from "./ApiSettings.vue?vue&type=script&lang=js"
export * from "./ApiSettings.vue?vue&type=script&lang=js"
import style0 from "./ApiSettings.vue?vue&type=style&index=0&id=9bd315e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd315e4",
  null
  
)

export default component.exports